module.exports = __webpack_public_path__ + "static/media/search.66331d6f.png";